import React from "react";
import { useCookieConsent } from "../context/CookieConsentContext";

export default function CookieSettingsLink() {
  const { openPreferences } = useCookieConsent();
  return (
    <button onClick={openPreferences} style={styles.link}>
      Cookie Settings
    </button>
  );
}

const styles = {
  link: {
    position: "fixed",
    bottom: 12,
    left: 12,
    background: "#2B373B",
    color: "#fff",
    border: "none",
    borderRadius: 4,
    padding: "6px 10px",
    fontSize: 12,
    cursor: "pointer",
    zIndex: 9998,
  },
};